import { Region, MetaData, PageData } from '@enonic/react-components';
import type { PageProps } from './PageProps.d';

import React from 'react';
import { Banner } from './Banner';
import { Footer } from './Footer';
import { Navbar } from './Navbar';


export function Page(pageParams: {
	common?: Record<string, unknown>;
	component: PageData;
	data: PageProps;
	meta: MetaData;
}): JSX.Element {
	// console.debug('Page pageParams', pageParams);
	const { component, data, meta } = pageParams;
	const { banner, footer, isStartPage, navbar } = data;
	return (
		<div className="flex min-h-screen flex-col bg-background-default">
			<Banner {...banner}/>
			<Navbar {...navbar}/>
			{isStartPage ? <h1 className="sr-only">Startside Overdosefare</h1> : ''}
			<Region
				as='main'
				// NOTE: I don't think xp-region is needed here:
				// className="xp-region flex-grow"
				className="flex-grow"
				data={component.regions.main.components}
				meta={meta}
				name="main"
			/>
			<Footer {...footer}/>
		</div>
	);
}
